import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteStaff(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteStaff = (staffId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`staff/${staffId}/`);
  };

  return useMutation(deleteStaff, {
    onSuccess: () => {
      queryClient.removeQueries(['staff']);
      queryClient.invalidateQueries(['classes']);
      queryClient.invalidateQueries(['appointments']);
      queryClient.invalidateQueries('events');
      queryClient.invalidateQueries('staff-autocomplete');
    },
  });
}
